import { Injectable } from "@angular/core";
import { ApiEnum, HttpDataService } from "./http-data.service";
import { CebePalViewModel } from "../models/centros/cebe-pal.model";
import { Observable, map, retry, catchError } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: "root",
})
export class CebePalService {
	constructor(private readonly httpDataService: HttpDataService) {}

	getPalByCebe(cebeId: number): Observable<CebePalViewModel> {
		return this.httpDataService
			.get$<CebePalViewModel>(
				ApiEnum.API_ROOT,
				`${environment.endpoint.cebePal.getPalByCebe}/${cebeId}`,
			)
			.pipe(
				map((pal) => {
					return pal;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<CebePalViewModel>(
						"getPalByCebe",
					),
				),
			);
	}

	getPalByContrato(contratoId: number): Observable<CebePalViewModel> {
		return this.httpDataService
			.get$<CebePalViewModel>(
				ApiEnum.API_ROOT,
				`/ContratoPal/GetPalByContrato/${contratoId}`,
			)
			.pipe(
				map((pal) => {
					return pal;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<CebePalViewModel>(
						"getPalByContrato",
					),
				),
			);
	}

	updateCebePal(pal: CebePalViewModel): Observable<CebePalViewModel> {
		return this.httpDataService
			.put$<CebePalViewModel>(
				ApiEnum.API_ROOT,
				environment.endpoint.cebePal.updatePal,
				pal,
			)
			.pipe(
				map((pal) => {
					return pal;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<CebePalViewModel>(
						"updateCebePal",
					),
				),
			);
	}

	createCebePal(pal: CebePalViewModel): Observable<CebePalViewModel> {
		return this.httpDataService
			.post$<CebePalViewModel>(
				ApiEnum.API_ROOT,
				environment.endpoint.cebePal.createPal,
				pal,
			)
			.pipe(
				map((pal) => {
					return pal;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<CebePalViewModel>(
						"createCebePal",
					),
				),
			);
	}
}
